import ApplicationAdapter from '../application';

export default class Enrolment extends ApplicationAdapter {
  namespace = 'people/v4';
  modelNamePlural = 'enrolments';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('people/', '')
      .toLowerCase();
  }
}
